import axios, { AxiosPromise } from 'axios';

import { IGrade } from '../../../@types/model/masterData/grade/grade';
import { IGradeUpsert } from '../../../@types/model/masterData/grade/gradeUpsert';

export default class GradeHttpService {
    public static getGradeData() : AxiosPromise<Array<IGrade>> {
        return axios.get(`${API_URL}/v1/Grade/GetAllWeb`);
    }

    public static addOrUpdateGrade(upsert : IGradeUpsert) : AxiosPromise<IGrade> {
        return axios.post(`${API_URL}/v1/Grade/PostGrade`, upsert);
    }

    public static deleteGrade(gradeId : number) : AxiosPromise<IGrade> {
        return axios.delete(`${API_URL}/v1/Grade/Delete`, {
            params : { gradeId },
        });
    }
}
